import React from "react";

class LoseScreen extends React.Component {
  render() {
    return <div>You Lose! Everyone dies!</div>;
  }
}

export default LoseScreen;
